module.exports = __webpack_public_path__ + "img/invalid-mobile.25fb6aae.png";